/**
 * Chemical beaker icon component for the targeted support application.
 * Represents testing or experimental features.
 */
import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

// @ts-expect-error - LucideIcon is not a valid prop for the forwardRef component
export const ChemicalBeakerIcon: React.ForwardRefExoticComponent<
  Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>
> = forwardRef<SVGSVGElement, LucideIcon>((props, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M7.4205 2.625V8.625L4.6755 11.5988C3.9765 12.5475 2.57925 14.0557 3.9645 15.0652C4.3905 15.375 5.17575 15.375 6.747 15.375H11.2537C12.8242 15.375 13.6095 15.375 14.0355 15.0652C15.4208 14.0557 14.0235 12.5475 13.3237 11.5988L10.5787 8.625V2.625M10.5787 2.625H7.42125H6.63M10.5787 2.625H11.3685"
      stroke="#94A3B8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
